/**
 * Export `colors`.
 */

export const colors = {
  black: '#000000',
  blue: '#0000ff',
  gray100: '#f5f5f5',
  gray200: '#e5e5e5',
  gray300: '#d4d4d4',
  gray400: '#a3a3a3',
  gray500: '#737373',
  gray600: '#525252',
  gray700: '#404040',
  gray800: '#262626',
  gray900: '#171717',
  primary100: '#E1E5EC',
  primary200: '#BFC8DA',
  primary300: '#9DAAC8',
  primary400: '#7B8DB6',
  primary500: '#5A6FA4',
  primary600: '#395292',
  primary700: '#071939',
  primary800: '#050F26',
  primary900: '#020813',
  white: '#ffffff',
};
